import { z } from "zod";

// Single source of truth: the on-disk cap. The writer trims to this; the schema
// asserts to this. Drift between writer and schema would silently break reads.
export const MAX_STORED_MESSAGES = 200;

export const BotMessageSchema = z.object({
  role: z.enum(["user", "assistant"]),
  content: z.string().min(1).max(8000),
  ts: z.number().int().positive(),
});
export type TBotMessage = z.infer<typeof BotMessageSchema>;

// Active task draft. Null/missing = no task in progress (user is in Q&A mode).
// The activeTask string is validated at runtime against the task registry.
export const DraftRequestSchema = z.object({
  activeTask: z.string().min(1).max(64),
  collectedValues: z.record(z.string(), z.string()),
  startedAt: z.number().int().positive(),
  doneAt: z.number().int().positive().nullable().optional(),
});
export type TDraftRequest = z.infer<typeof DraftRequestSchema>;

export const BotConversationSchema = z.object({
  chatId: z.union([z.number().int(), z.string()]),
  platform: z.union([z.literal("telegram"), z.literal("whatsapp")]),
  messages: z.array(BotMessageSchema).max(MAX_STORED_MESSAGES),
  updatedAt: z.number().int().positive(),
  messageCount: z.number().int().nonnegative(),
  // null or undefined both mean "no task active"; optional for backwards-compat
  // with old docs persisted before drafts existed.
  draftRequest: DraftRequestSchema.nullish(),
});
export type TBotConversation = z.infer<typeof BotConversationSchema>;
